import { render, staticRenderFns } from "./Finished.vue?vue&type=template&id=58a87d52&scoped=true&"
import script from "./Finished.vue?vue&type=script&lang=js&"
export * from "./Finished.vue?vue&type=script&lang=js&"
import style0 from "./Finished.vue?vue&type=style&index=0&id=58a87d52&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a87d52",
  null
  
)

export default component.exports